import type { CompanyLocationBasicInfoInDTO, CompanyLocationsDetailOutDTO } from '@api/ringil-api.v2';

/**
 * RD-3062 — the save body of `LocalityDetail`, moved out of the component unchanged so it can be unit-tested.
 */

/**
 * The basic-info update every tag on the detail page sends: the whole current location with the edited
 * fields laid over it, because the endpoint replaces all of them.
 */
export const locationBasicInfoRequest = (data: CompanyLocationsDetailOutDTO, overrides: Partial<CompanyLocationBasicInfoInDTO>): CompanyLocationBasicInfoInDTO => {
  const body: CompanyLocationBasicInfoInDTO = {
    name: data.name,
    streetNr: data.streetNr,
    city: data.city,
    postalCode: data.postalCode,
    country: data.country,
    timezoneId: data.timezoneId,
    externalId: data.externalId,
    externalIds: data.externalIds,
    enableVisitor: data.enableVisitor,
    isPartnerLocation: data.isPartnerLocation,
    locationNote: data.locationNote,
    latitude: data.latitude,
    longitude: data.longitude,
    ...overrides,
  };
  return body;
};
